import { connect } from 'react-redux'
import { getFromSettings } from 'src/utils/helpers'

import Loading from './Loading'

const mapStateToProps = state => {
  return {
    brand: getFromSettings(state, 'brand', {}),
  }
}

export default connect(mapStateToProps, null)(Loading)
